import { Link } from "react-router-dom";
require("utility/empty_state_container.scss")

class EmptyStateContainer extends React.Component {
	constructor(props) {
		super();
		autobind(this);
		this.state = { }
	}
	
	renderLeftContent() {
		var widths = [120, 105, 95];

		var emptyStudentRows = [];
		var owlImgSrc = require("owls/owl-outline.png");
		for (var i = 0; i <= 10; i++) {
			var width = _.sample(widths, 1);
			emptyStudentRows.push(
				<div className="emptyStudentRowContainer" key={ i }>
					<img src={ owlImgSrc } alt=""/>
					<span className="emptyStudentRow" style={{ width: width }}></span>
				</div>
			)
		};
		return (
			<div>
				{ emptyStudentRows }
			</div>
		);
	}
	
	renderRightContent() {
		if (this.props.linkPath) {
			var image = (
				<Link to={ this.props.linkPath }>
					<img src={ this.props.imagePath } className="emptyImg" />
				</Link>
			)
		} else {
			var image = (<img src={ this.props.imagePath } className="emptyImg" />)
		}
		return (
			<div>
				<p>{ this.props.statusText }</p>
				{ this.props.actionText }
				{ image }		
			</div>
		);
	}
	render() {
		var imagePath = this.props.imagePath
		if (this.props.sideBar) {
			var emptyStateContent = (
				<div className="row">
					<div className="col-sm-3 sideBar">
						{ this.renderLeftContent() }
					</div>
					<div className="col-sm-9 rightContent emptyRightContent">
						{ this.renderRightContent() }
					</div>
				</div>
			)
		} else {
			if (this.props.linkPath) {
				var image = (
					<Link to={ this.props.linkPath }>
						<img src={ imagePath } className="emptyImg" />
					</Link>	
				)
			} else {
				var image = (<img src={ imagePath } className="emptyImg" />)
			}
			var emptyStateContent = (
				<div className="emptyStateContent">
					<p>{ this.props.statusText }</p>
					{ this.props.actionText }
					{ image }
				</div>
			)	
		}
		return (
			<div className="container emptyStateContainer">
				{ emptyStateContent }
			</div>	
		);
	}
}

EmptyStateContainer.propTypes = StrictPropTypes({
	statusText: PropTypes.string,
	imagePath: PropTypes.string,
	className: PropTypes.string,
	linkPath: PropTypes.string,
	actionText: PropTypes.object,
	sideBar: PropTypes.bool, 
});

module.exports = EmptyStateContainer;


// WEBPACK FOOTER //
// ./modules/components/utility/EmptyStateContainer.js